module.exports = __webpack_public_path__ + "static/media/3.question.1b725000.mp4";